import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Link as RouterLink } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Badge from '@material-ui/core/Badge'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Popover from '@material-ui/core/Popover'
import Toolbar from '@material-ui/core/Toolbar'
import Hidden from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import SvgIcon from '@material-ui/core/SvgIcon'
import Logo from 'assets/images/dokify-logo-small.svg'
import { ReactComponent as IconClose } from 'assets/icons/close.svg'
import { ReactComponent as IconMenu } from 'assets/icons/menu.svg'
import { ReactComponent as IconNotifications } from 'assets/icons/notifications.svg'
import { ReactComponent as IconApps } from 'assets/icons/apps.svg'
import { useSelector } from 'react-redux'
import { getUser, getUserLocale } from 'services/auth/selectors'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'

const Header = props => {
  const t = useTranslation()
  const {
    open,
    setOpen,
    isLogged,
    isLanding,
    onLoginClick,
    onClickNotifications,
    unreadNotifications = 0,
  } = props
  const classes = useStyles()
  const handleToggleDrawer = () => {
    setOpen(!open)
  }

  const user = useSelector(getUser)
  const userAvailableModules = user ? user.available_modules : null
  const userModules = userAvailableModules
    ? userAvailableModules.filter(module => {
        return module.id !== 'homologation'
      })
    : null

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleModulesClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleModulesClose = () => {
    setAnchorEl(null)
  }

  const modulesOpen = Boolean(anchorEl)
  const modulesId = modulesOpen ? 'simple-popover' : undefined
  const userLocale = useSelector(getUserLocale)

  return (
    <AppBar
      position="absolute"
      color="transparent"
      elevation={1}
      className={clsx(
        classes.header,
        open && classes.headerExpanded,
        !isLogged && classes.headerFullwidth,
        isLanding && classes.headerLanding,
        isLanding & open && classes.headerLandingExpanded,
      )}
    >
      <Toolbar className={classes.headerToolbar}>
        <Hidden smUp>
          <IconButton
            color="inherit"
            className={clsx(
              classes.headerTrigger,
              open && classes.headerTriggerOpen,
              isLanding && classes.headerTriggerOpen,
            )}
            onClick={handleToggleDrawer}
          >
            <SvgIcon component={open ? IconClose : IconMenu} />
          </IconButton>
        </Hidden>
        {isLogged && userModules && userModules.length > 0 ? (
          <div>
            <IconButton
              color="inherit"
              className={clsx(
                classes.headerTrigger,
                open && classes.headerTriggerOpen,
                isLanding && classes.headerTriggerOpen,
              )}
              onClick={handleModulesClick}
            >
              <SvgIcon component={IconApps} />
            </IconButton>
            <Popover
              id={modulesId}
              open={modulesOpen}
              anchorEl={anchorEl}
              onClose={handleModulesClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <List>
                {userModules.map(
                  ({ id, login_url, context, title, subtitle }) => (
                    <ListItem
                      key={id}
                      button
                      component={Link}
                      href={login_url + '?lang=' + userLocale}
                    >
                      <ListItemIcon>
                        <img
                          src={require(
                            'assets/images/logo-' + context + '.png',
                          )}
                          alt={t(title) + ' - ' + t(subtitle)}
                        />
                        &nbsp;&nbsp;
                        <Typography className="logoTitle" variant="body2">
                          {t(title)}
                        </Typography>
                        &nbsp;
                        <Typography className="logoSubtitle" variant="body2">
                          {t(subtitle)}
                        </Typography>
                      </ListItemIcon>
                    </ListItem>
                  ),
                )}
              </List>
            </Popover>
          </div>
        ) : null}
        <div className={classes.headerTitleWrap}>
          <Link
            className={classes.headerTitle}
            component={RouterLink}
            variant="body2"
            to="/"
          >
            <img className={classes.headerTitleIcon} src={Logo} alt="" />
            <Typography
              className={clsx(
                classes.headerTitleText,
                isLanding && classes.headerTitleTextLanding,
              )}
              component="h1"
              variant="h1"
              noWrap
            >
              {t('header:title')}
            </Typography>
          </Link>
        </div>
        {isLogged ? (
          <IconButton
            style={{ display: 'none' }}
            className={clsx(
              classes.headerNotifications,
              open && classes.headerNotificationsOpen,
            )}
            onClick={onClickNotifications}
          >
            <Badge badgeContent={unreadNotifications} color="error">
              <SvgIcon component={IconNotifications} />
            </Badge>
          </IconButton>
        ) : (
          <>
            <Hidden smUp>
              <Box width={24} height={24} />
            </Hidden>
            <Hidden xsDown>
              <Link
                color="primary"
                className={isLanding && classes.headerButtonLanding}
                onClick={onLoginClick}
              >
                {t('login:title')}
              </Link>
            </Hidden>
          </>
        )}
      </Toolbar>
    </AppBar>
  )
}

Header.propTypes = {
  isLogged: PropTypes.bool,
  onLoginClick: PropTypes.func,
}

export default Header
